import { render, staticRenderFns } from "./ClaimVoucher.vue?vue&type=template&id=b26a3868&lang=pug"
import script from "./ClaimVoucher.vue?vue&type=script&lang=js"
export * from "./ClaimVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports